const HOUR_CADENCE_LABELS: Record<string, number> = {
  "24 Hours": 24,
  "12 Hours": 12,
  "6 Hours": 6,
  "4 Hours": 4,
};

const HOUR_CADENCE_VALUES: Record<number, string> = {
  24: "24 Hours",
  12: "12 Hours",
  6: "6 Hours",
  4: "4 Hours",
};

export const cadenceOptions = [
  "24 Hours",
  "12 Hours",
  "6 Hours",
  "4 Hours",
  "120",
  "60",
  "30",
  "15",
];

export const formatCadenceForDisplay = (
  cadence: number | string | null | undefined
): string => {
  if (cadence == null || cadence === "") {
    return "";
  }

  const value = Number(cadence);
  if (!Number.isNaN(value) && HOUR_CADENCE_VALUES[value]) {
    return HOUR_CADENCE_VALUES[value];
  }

  return String(cadence);
};

export const cadenceLabelToMinutes = (label: string): string => {
  if (HOUR_CADENCE_LABELS[label] != null) {
    return String(HOUR_CADENCE_LABELS[label]);
  }

  return label;
};

export const cadenceMinutesToLabel = (
  cadence: number | string | null | undefined
): string => {
  return formatCadenceForDisplay(cadence);
};
